import apiClient from "./apiClient";

export const getPolicySummary = async () => {
  const response = await apiClient.get("/dashboard/policy-summary");
  return response?.data || null;
};
